module.exports = __webpack_public_path__ + "static/img/pdf.939449c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat/images/chat_files/pdf.png
// module id = /sge
// module chunks = 1